import React from 'react';
import './ContactUs.css';

const ContactUs = () => {
  return (
    <section className="contact-us-section py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h2 className="contact-us-title mb-4">Contact Us</h2>
            <p className="contact-us-subtitle mb-5">
              Have questions or feedback? We'd love to hear from you!
            </p>
            
            <div className="contact-us-info mb-5">
              <div className="contact-info-item">
                <i className="fas fa-envelope contact-icon"></i>
                <span>Email: healthwiibes@gmail.com</span>
              </div>
            </div>

            <form className="contact-us-form">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <input 
                    type="text" 
                    className="contact-input" 
                    placeholder="Your Name" 
                    required 
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <input 
                    type="email" 
                    className="contact-input" 
                    placeholder="Your Email" 
                    required 
                  />
                </div>
              </div>
              <div className="mb-4">
                <input 
                  type="text" 
                  className="contact-input" 
                  placeholder="Subject" 
                  required 
                />
              </div>
              <div className="mb-4">
                <textarea 
                  className="contact-textarea" 
                  rows="5" 
                  placeholder="Your Message" 
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn contact-submit-btn">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;